// 🔧 seo_defaults.js
// ✅ Purpose: Creates SEO content for Seed Engine events
// ✅ Features:
// - Generates realistic SEO title and description
// - Supports industry-specific SEO
// - Future-ready for AI-generated SEO
// - Mirrors the real SEO fields used by LGV
// - Fully block-commented for clarity and future devs

export const buildSeoSettings = ({
  eventName,
  industryTemplate,
} = {}) => {
  const industry =
    industryTemplate?.label || "Car Show";

  return {
    seoTitle:
      `${eventName} | ${industry} | Let's Go Vote`,

    seoDescription:
      `Explore the ${eventName} demo event powered by Let's Go Vote. Browse entries, vote, view leaderboards, schedules, sponsors, maps, and event results.`,

    seoKeywords: [
      industry,
      "People's Choice",
      "Voting",
      "Event",
      "Leaderboard",
      "QR Voting",
      "Let's Go Vote",
    ].join(", "),
  };
};